import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class CheckAuthService implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const subject = new Rx.ReplaySubject<boolean>();
    const loggedIn = this._authService.isLoggedIn().subscribe(bool => {
      if (!bool) {
        this._router.navigateByUrl('/');
      }
      let roleCheck = true;

      if (route.data && route.data.roles) {
        roleCheck = route.data.roles.find(r => this._authService.hasProfile(r)) != null;
      }
      subject.next(bool && roleCheck);

      // subject.next(bool);
    });

    return subject.asObservable();
  }

  constructor(private _router: Router, private _authService: AuthService) {
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/check-auth.service.ts